




























































// 3rd party lib
import {
    mapGetters,
} from 'vuex';

// Components
import translationString from '@webapp/components/translation-string.vue';

export default {
    name: 'token-participation-amount',
    components: {
        translationString,
    },
    props: {
        amount: {
            type: Number,
            default: 0,
        },
        translationFanToken: {
            type: String,
            default: null,
        },
        partnerId: {
            type: String,
            default: null,
        },
        cardView: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('partners', ['partnerById']),

        ...mapGetters('wallet', ['decentralizedLedgerByToken']),

        ...mapGetters('voteTokens', ['getVoteTokenByCurrencyId']),

        partnerData() {
            return this.partnerId ? this.partnerById(this.partnerId) : {};
        },

        participationAmount() {
            return `${this.amount} ${this.partnerData.shortName}`;
        },

        userHasTokens() {
            if (!this.partnerId) {
                return false;
            }

            const voteToken = this.getVoteTokenByCurrencyId(this.partnerData.currencyId);

            if (voteToken.currencyId) {
                const {
                    balance = 0,
                    lockedBalance = 0,
                } = this.decentralizedLedgerByToken(voteToken.currencyId);

                const userTokens = Number(balance) + Number(lockedBalance);

                return userTokens >= this.amount;
            }

            return false;
        },
    },
};
